interface OrnamentProps {
  className?: string;
  variant?: "default" | "lozenge" | "rule";
}

export function Ornament({ className = "", variant = "default" }: OrnamentProps) {
  if (variant === "lozenge") {
    return (
      <svg
        viewBox="0 0 24 24"
        aria-hidden="true"
        className={className}
        fill="none"
      >
        <path
          d="M12 1 L23 12 L12 23 L1 12 Z"
          stroke="currentColor"
          strokeWidth="0.8"
        />
        <circle cx="12" cy="12" r="1.6" fill="currentColor" />
      </svg>
    );
  }

  if (variant === "rule") {
    return (
      <svg
        viewBox="0 0 120 8"
        aria-hidden="true"
        className={className}
        fill="none"
      >
        <line x1="0" y1="4" x2="56" y2="4" stroke="currentColor" strokeWidth="0.6" />
        <circle cx="60" cy="4" r="1.4" fill="currentColor" />
        <line x1="64" y1="4" x2="120" y2="4" stroke="currentColor" strokeWidth="0.6" />
      </svg>
    );
  }

  return (
    <svg
      viewBox="0 0 96 16"
      aria-hidden="true"
      className={className}
      fill="none"
    >
      <line x1="0" y1="8" x2="32" y2="8" stroke="currentColor" strokeWidth="0.7" />
      <path
        d="M40 3 L48 8 L40 13 Z M56 3 L48 8 L56 13 Z"
        stroke="currentColor"
        strokeWidth="0.7"
      />
      <circle cx="48" cy="8" r="1.3" fill="currentColor" />
      <line x1="64" y1="8" x2="96" y2="8" stroke="currentColor" strokeWidth="0.7" />
    </svg>
  );
}
